import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabpunetomumbai() {



  const cardData = {


  keyword: "One Way Cab Pune to Mumbai",

  headingDescription: "Trustline Cab offers dependable one way cab Pune to Mumbai services with safe, comfortable, and budget-friendly taxi solutions for business travel, airport transfers, corporate meetings, family visits, and outstation journeys. Whether you're traveling to Mumbai for work, leisure, medical appointments, or a special occasion, our experienced chauffeurs ensure timely pickups and a smooth, hassle-free ride. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel need. With transparent one-way fares, doorstep pickup, easy online booking, flexible departure timings, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mumbai one way taxi services.",

  topPlaces: [
    {
      title: "Andheri",
      description: "Andheri is one of Mumbai's busiest commercial and residential hubs, known for IT companies, business parks, entertainment centers, premium hotels, and excellent metro connectivity. Its strategic location near the airport makes it a preferred destination for corporate travelers and business professionals."
    },
    {
      title: "Goregaon",
      description: "Goregaon is a rapidly developing business district featuring IT parks, commercial complexes, exhibition centers, film studios, and modern infrastructure. It attracts professionals, corporate visitors, and event attendees from across India throughout the year."
    },
    {
      title: "Vikhroli",
      description: "Vikhroli is an important commercial locality in eastern Mumbai, home to corporate offices, technology companies, industrial establishments, and premium business spaces. It offers excellent connectivity to Powai, Thane, and Navi Mumbai."
    },
    {
      title: "Mahape",
      description: "Mahape is a prominent technology and industrial destination in Navi Mumbai, housing software companies, multinational corporations, engineering firms, and business parks. It is widely visited by professionals for corporate meetings and business operations."
    },
    {
      title: "Taloja MIDC",
      description: "Taloja MIDC is one of Maharashtra's major industrial hubs with chemical industries, manufacturing units, logistics companies, engineering businesses, and commercial establishments. It serves as an important destination for industrial and corporate travel."
    },
    {
      title: "Rabale",
      description: "Rabale is a growing industrial and commercial area in Navi Mumbai known for manufacturing companies, warehouses, technology firms, and business centers. Its excellent road connectivity makes it a convenient destination for business visitors."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is a magnificent meditation center near Gorai, admired for its massive golden dome, peaceful surroundings, and architectural beauty. It is a popular destination for spiritual seekers and tourists visiting Mumbai."
    },
    {
      title: "EsselWorld Waterfront",
      description: "The EsselWorld waterfront area near Gorai offers beautiful coastal views, ferry access, family-friendly attractions, and a relaxing environment. It is a popular leisure destination for visitors exploring the western coastline of Mumbai."
    },
    {
      title: "Madh Island",
      description: "Madh Island is a peaceful coastal retreat known for its beaches, fishing villages, seaside resorts, and scenic landscapes. It provides a refreshing escape from the city's fast-paced environment and is popular among weekend travelers."
    },
    {
      title: "Gilbert Hill",
      description: "Gilbert Hill is a rare geological landmark in Andheri formed from ancient volcanic basalt rock. It offers historical significance, panoramic city views, and attracts tourists interested in Mumbai's unique natural heritage."
    }
  ],






"services": [
  {
    "name": "Pune Mumbai Cab One Way",
    "description": "Book Pune Mumbai Cab One Way service for comfortable and affordable single-side travel between Pune and Mumbai. Enjoy professional chauffeurs, clean AC vehicles, doorstep pickup, transparent pricing, and multiple vehicle options including Sedan, Ertiga, Innova Crysta, SUV, and premium cars for airport transfers, business travel, family trips, and outstation journeys."
  },
  {
    "name": "One Way Cab Pune to Mumbai",
    "description": "Choose One Way Cab Pune to Mumbai for convenient destination travel without return charges. Our one-way taxi service provides experienced drivers, well-maintained vehicles, flexible pickup locations, affordable fares, and reliable transportation for personal, corporate, and airport travel."
  },
  {
    "name": "Pune to Mumbai Taxi One Way",
    "description": "Book Pune to Mumbai Taxi One Way with professional chauffeurs and comfortable AC cars. Travel safely with fixed pricing, quick booking, spacious vehicles, and reliable service for airport drops, business meetings, family journeys, and long-distance travel."
  },
  {
    "name": "One Way Cab Pune to Mumbai Airport",
    "description": "Reserve One Way Cab Pune to Mumbai Airport for timely airport transfers with skilled drivers, clean vehicles, luggage-friendly options, and affordable fares. Enjoy stress-free travel from Pune to Mumbai Airport with doorstep pickup and punctual service."
  },
  {
    "name": "One Way Pune to Mumbai",
    "description": "Book One Way Pune to Mumbai cab service for direct travel with no return fare. Get premium Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles with experienced chauffeurs and comfortable highway journeys."
  },
  {
    "name": "One Way Cab Pune to Mumbai",
    "description": "Hire One Way Cab Pune to Mumbai for safe and economical intercity travel. Our service offers flexible booking, transparent pricing, professional drivers, and comfortable vehicles suitable for individuals, families, and corporate travelers."
  },
  {
    "name": "Pune to Mumbai One Way Cab",
    "description": "Book Pune to Mumbai One Way Cab for affordable point-to-point travel with premium AC vehicles, professional drivers, and reliable pickup service. Ideal for airport transfers, railway station drops, office travel, and personal journeys."
  },
  {
    "name": "Pune to Mumbai One Way Taxi",
    "description": "Choose Pune to Mumbai One Way Taxi for convenient travel with fixed fares, experienced chauffeurs, clean vehicles, and comfortable seating. Enjoy smooth transportation between Pune and Mumbai with reliable taxi service."
  },
  {
    "name": "Pune to Mumbai Cab",
    "description": "Book Pune to Mumbai Cab for safe and comfortable intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and premium cars. Get professional drivers, affordable pricing, doorstep pickup, and 24x7 booking support."
  },
  {
    "name": "Pune to Mumbai Taxi",
    "description": "Travel with Pune to Mumbai Taxi service offering reliable transportation, AC vehicles, experienced chauffeurs, transparent pricing, and flexible booking options for business, family, airport, and personal travel."
  },
  {
    "name": "Pune to Mumbai Cab Service",
    "description": "Our Pune to Mumbai Cab Service provides one-way and outstation taxi solutions with professional drivers, sanitized vehicles, affordable fares, and comfortable travel options for every passenger requirement."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Book Pune to Mumbai Taxi Service for premium intercity transportation with well-maintained cars, punctual pickup, skilled drivers, and dependable customer assistance throughout your journey."
  },
  {
    "name": "Pune to Mumbai Cab Booking",
    "description": "Complete Pune to Mumbai Cab Booking online with easy reservation, instant confirmation, multiple vehicle choices, transparent fares, and reliable chauffeur-driven taxi service."
  },
  {
    "name": "Book Pune to Mumbai One Way Cab",
    "description": "Book Pune to Mumbai One Way Cab for hassle-free single destination travel with affordable rates, professional drivers, comfortable vehicles, and convenient pickup service from Pune locations."
  },
  {
    "name": "Online Pune to Mumbai One Way Cab",
    "description": "Use Online Pune to Mumbai One Way Cab booking to reserve your preferred vehicle quickly with instant confirmation, transparent pricing, and reliable travel assistance."
  },
  {
    "name": "Pune to Mumbai One Side Cab",
    "description": "Choose Pune to Mumbai One Side Cab for direct travel without return charges. Enjoy affordable fares, premium vehicles, professional chauffeurs, and comfortable long-distance transportation."
  },
  {
    "name": "Pune to Mumbai Drop Taxi",
    "description": "Book Pune to Mumbai Drop Taxi for direct destination drop service with clean AC cars, experienced drivers, fixed pricing, and convenient travel solutions."
  },
  {
    "name": "Pune to Mumbai Drop Cab",
    "description": "Hire Pune to Mumbai Drop Cab for reliable one-way transportation with affordable pricing, doorstep pickup, and comfortable vehicles for personal and business travel."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Travel safely with Pune to Mumbai Outstation Cab featuring professional chauffeurs, premium vehicles, highway travel comfort, and flexible booking options."
  },
  {
    "name": "Pune to Mumbai Intercity Cab",
    "description": "Book Pune to Mumbai Intercity Cab for convenient city-to-city transportation with experienced drivers, AC vehicles, transparent fares, and reliable service."
  },
  {
    "name": "Pune to Mumbai Private Cab",
    "description": "Hire Pune to Mumbai Private Cab for exclusive travel with privacy, flexible schedules, comfortable seating, and professional chauffeur service."
  },
  {
    "name": "Pune to Mumbai AC Cab",
    "description": "Choose Pune to Mumbai AC Cab with clean air-conditioned vehicles, comfortable interiors, skilled drivers, and smooth highway travel experience."
  },
  {
    "name": "Pune to Mumbai Car Rental",
    "description": "Select Pune to Mumbai Car Rental service with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for flexible travel needs."
  },
  {
    "name": "Innova Crysta One Way Cab Pune to Mumbai",
    "description": "Book Innova Crysta One Way Cab Pune to Mumbai for luxury family and corporate travel with spacious seating, premium comfort, professional drivers, and affordable one-way fares."
  },
  {
    "name": "Ertiga One Way Cab Pune to Mumbai",
    "description": "Hire Ertiga One Way Cab Pune to Mumbai for comfortable group travel with 6 to 7 seater capacity, experienced chauffeurs, and economical pricing."
  },
  {
    "name": "Sedan One Way Cab Pune to Mumbai",
    "description": "Choose Sedan One Way Cab Pune to Mumbai for budget-friendly travel with comfortable seating, clean vehicles, professional drivers, and reliable service."
  },
  {
    "name": "Kia Carens One Way Cab Pune to Mumbai",
    "description": "Book Kia Carens One Way Cab Pune to Mumbai for premium family journeys with spacious interiors, luxury comfort, and smooth highway travel."
  },
  {
    "name": "Swift Dzire One Way Cab Pune to Mumbai",
    "description": "Hire Swift Dzire One Way Cab Pune to Mumbai for economical and comfortable travel with affordable fares and professional chauffeur service."
  },
  {
    "name": "Hyundai Aura One Way Cab Pune to Mumbai",
    "description": "Book Hyundai Aura One Way Cab Pune to Mumbai for reliable budget travel with clean AC vehicles and experienced drivers."
  },
  {
    "name": "SUV One Way Cab Pune to Mumbai",
    "description": "Choose SUV One Way Cab Pune to Mumbai for premium space, comfortable seating, luggage capacity, and safe long-distance travel."
  },
  {
    "name": "Premium One Way Cab Pune to Mumbai",
    "description": "Experience Premium One Way Cab Pune to Mumbai with luxury vehicles, professional chauffeurs, superior comfort, and reliable transportation."
  },
  {
    "name": "Luxury One Way Taxi Pune to Mumbai",
    "description": "Book Luxury One Way Taxi Pune to Mumbai for premium travel experience with high-end vehicles, professional drivers, and customized travel solutions."
  },
  {
    "name": "Family One Way Cab Pune to Mumbai",
    "description": "Choose Family One Way Cab Pune to Mumbai for safe family journeys with spacious vehicles, comfortable seating, experienced drivers, and affordable fares."
  }
],

"tableData": [
  ["Pune Mumbai Cab One Way", "One Way Cab Pune to Mumbai"],
  ["Pune to Mumbai Taxi One Way", "One Way Cab Pune to Mumbai Airport"],
  ["Pune to Mumbai One Way Cab", "Pune to Mumbai One Way Taxi"],
  ["Pune to Mumbai Cab", "Pune to Mumbai Taxi"],
  ["Pune to Mumbai Cab Service", "Pune to Mumbai Taxi Service"],
  ["Pune to Mumbai Cab Booking", "Book Pune to Mumbai One Way Cab"],
  ["Online Pune to Mumbai One Way Cab", "Pune to Mumbai One Side Cab"],
  ["Pune to Mumbai Drop Taxi", "Pune to Mumbai Drop Cab"],
  ["Pune to Mumbai Outstation Cab", "Pune to Mumbai Intercity Cab"],
  ["Pune to Mumbai Private Cab", "Pune to Mumbai AC Cab"],
  ["Pune to Mumbai Car Rental", "Innova Crysta One Way Cab Pune to Mumbai"],
  ["Ertiga One Way Cab Pune to Mumbai", "Sedan One Way Cab Pune to Mumbai"],
  ["Kia Carens One Way Cab Pune to Mumbai", "Swift Dzire One Way Cab Pune to Mumbai"],
  ["Hyundai Aura One Way Cab Pune to Mumbai", "SUV One Way Cab Pune to Mumbai"],
  ["Premium One Way Cab Pune to Mumbai", "Luxury One Way Taxi Pune to Mumbai"],
  ["Family One Way Cab Pune to Mumbai", ""]
],





whychoose: [
  {
    WhyChooseheading: "Affordable One Way Cab Pune to Mumbai",
    WhyChoosedescription: "Trustline Cab provides reliable one way cab services from Pune to Mumbai with economical fares, comfortable vehicles, and professional travel assistance."
  },
  {
    WhyChooseheading: "Pay Only for One-Way Travel",
    WhyChoosedescription: "Our one way cab service helps you save money by charging only for your actual journey without unnecessary return-trip costs."
  },
  {
    WhyChooseheading: "Well-Maintained Fleet",
    WhyChoosedescription: "Travel in clean and regularly serviced Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for a comfortable ride."
  },
  {
    WhyChooseheading: "Professional Drivers with Route Expertise",
    WhyChoosedescription: "Experienced chauffeurs ensure safe driving, timely arrivals, and a hassle-free journey via the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Convenient Pickup & Drop",
    WhyChoosedescription: "Doorstep pickup is available from any location in Pune with drop service anywhere in Mumbai, including hotels, offices, residences, and airports."
  },
  {
    WhyChooseheading: "Transparent Fare Structure",
    WhyChoosedescription: "Receive clear pricing before booking with no hidden charges, making your one way cab booking simple and trustworthy."
  },
  {
    WhyChooseheading: "Perfect for Business & Personal Travel",
    WhyChoosedescription: "Whether you're traveling for meetings, airport transfers, family visits, or vacations, our one way cab service suits every travel purpose."
  },
  {
    WhyChooseheading: "Instant Confirmation & 24/7 Booking",
    WhyChoosedescription: "Book your One Way Cab Pune to Mumbai anytime with quick confirmation and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide One Way Cab Pune to Mumbai?",
    answer: "Yes, Trustline Cab offers reliable one way cab services from Pune to Mumbai with affordable pricing and comfortable vehicles."
  },
  {
    question: "Can I book a one way cab from any area in Pune?",
    answer: "Yes, we provide doorstep pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major locations across Pune."
  },
  {
    question: "Which vehicles are available for one way travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers depending on your travel requirements."
  },
  {
    question: "Is the one way cab service available every day?",
    answer: "Yes, our One Way Cab Pune to Mumbai service operates 24 hours a day, including weekends and public holidays."
  },
  {
    question: "Can I book a one way cab for Mumbai Airport?",
    answer: "Yes, we provide direct one way cab services to Mumbai Airport Terminal 1, Terminal 2, and nearby locations."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable state taxes are generally charged separately unless specifically included in the booking quotation."
  },
  {
    question: "Is advance booking necessary?",
    answer: "Advance booking is recommended to ensure your preferred vehicle and pickup schedule, although same-day bookings are also available based on availability."
  },
  {
    question: "Do you provide one way cabs for corporate travelers?",
    answer: "Yes, our one way cab service is widely used by business professionals, corporate employees, tourists, and families."
  },
  {
    question: "How long does it take to travel from Pune to Mumbai by cab?",
    answer: "The journey usually takes around 3.5 to 4.5 hours depending on traffic conditions and your drop location in Mumbai."
  },
  {
    question: "How can I book a One Way Cab Pune to Mumbai with Trustline Travels?",
    answer: "Simply share your pickup address, Mumbai destination, travel date, passenger details, and preferred vehicle to receive an instant fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Chavan",
    feedback: "Choosing Trustline Travels for a one way journey to Mumbai proved to be an excellent decision. The vehicle arrived on schedule, the ride was comfortable, and the overall service exceeded expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Radhika Nair",
    feedback: "From the initial inquiry to the final drop-off, everything was managed professionally. The clean cab, courteous chauffeur, and transparent pricing made the Pune to Mumbai journey completely worry-free.",
    rating: 5
  }
];



  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Pune to Mumbai",
  "image": "https://www.trustlinetravels.com/assets/images/one-way-cab-pune-to-mumbai.webp",
  "description": "Book one way cab Pune to Mumbai with Trustline Travels for affordable and comfortable intercity travel. Get reliable one-way taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options for Pune Mumbai routes available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7564"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/one-way-cab-pune-to-mumbai"
  }
};




  return (
    <div>

<Helmet>
  <title>One Way Cab Pune to Mumbai | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book one way cab Pune to Mumbai with Trustline Travels for safe and affordable travel. Get one-way taxi services from Pune to Mumbai Airport and city locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Pune Mumbai Cab One way, One way cab pune to mumbai, Pune to mumbai taxi one way, One way cab pune to mumbai airport, One way pune to mumbai, One Way Cab Pune to Mumbai, Pune to Mumbai One Way Cab, Pune to Mumbai One Way Taxi, Pune to Mumbai Cab, Pune to Mumbai Taxi, Pune Mumbai one way taxi booking, Pune Mumbai drop taxi, Pune airport to Mumbai one way cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabpunetomumbai;